@defer (on viewport) {
  <app-card>
    <app-card-header title="Ticket Médio de Depósitos (Últimos 30 dias)">
      <div class="flex flex-1 items-center justify-end gap-4">
        <p-datepicker
          size="small"
          dateFormat="dd/mm/yy"
          [(ngModel)]="selectedDate"
          (ngModelChange)="getDepositDailyMetrics()"
          appendTo="body"
          fluid
          class="w-28"
        />
        <p-button variant="text" size="small" (click)="getDepositDailyMetrics()">
          <i class="fa-solid fa-arrows-rotate"></i>
        </p-button>
      </div>
    </app-card-header>

    @if (loading() && !chartData()) {
      <div class="w-full h-96 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (chartData()?.datasets?.length) {
      <div class="w-full space-y-4">
        <div class="grid grid-cols-3 gap-4 px-2">
          <div class="flex flex-col items-center justify-center p-3 border border-zinc-200 rounded-lg">
            <span class="text-xs text-zinc-500">Total Depósitos</span>
            <span class="text-lg font-semibold text-zinc-800">{{ meta()?.total_qty | number }}</span>
          </div>
          <div class="flex flex-col items-center justify-center p-3 border border-zinc-200 rounded-lg">
            <span class="text-xs text-zinc-500">Valor Total</span>
            <span class="text-lg font-semibold text-zinc-800">{{ meta()?.total_value | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
          </div>
          <div class="flex flex-col items-center justify-center p-3 border border-zinc-200 rounded-lg">
            <span class="text-xs text-zinc-500">Ticket Médio Geral</span>
            <span class="text-lg font-semibold text-zinc-800">{{ meta()?.overall_avg | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
          </div>
        </div>
        <p-chart
          type="bar"
          [data]="chartData()"
          [options]="chartOptions()"
          class="w-full h-[400px]"
        />
      </div>
    } @else {
      <app-empty-chart />
    }
  </app-card>
} @placeholder {
  <p-skeleton height="32rem" />
}
